import { CoreState } from '../../../models';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class SetOpenEmpathizeMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.setOpenEmpathize]: (localState: CoreState, openEmpathize: boolean) => {
      localState.openEmpathize = openEmpathize;
    }
  };
}
